export default "__VITE_ASSET__bb3b693b__"